import React from 'react';
import G from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import "../../media/css/LibraryEditor.css";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import EditIcon from "../../media/images/EditIcon.mjs";
import CheckIcon from "../../media/images/CheckIcon.mjs";
import FormLibraryLeafNodeEditor from "../parts/FormLibraryLeafNodeEditor.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = 'ModalEditLibraryLeaf';

const ModalEditLibraryLeaf = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid(prefix);
	}
	render() {
		return(
			<Modal
				id={this.uid}
				isOpen={true}
				toggle={this.props.cancel}
				size="lg"
				onOpened={ appLib.modalAutoFocus }
			>
				<ModalHeader
					toggle={this.props.cancel}
				>
					<EditIcon />
					<TextLabel value={"Edit question"}/>
				</ModalHeader>
				<ModalBody>
					<FormLibraryLeafNodeEditor
						data={ this.props.data }
						languages={ this.props.languages }
						setData={ d => this.setState({ data: d })}
						setValid={ v => this.setState({ valid: v })}
					/>
				</ModalBody>
				<ModalFooter>
					<Button
						className={"btn-icon"}
						color={"primary"}
						disabled={ ! this.state.valid }
						onClick={ ()=> this.props.save( this.state.data ) }
					>
						<b>
							<TextLabel value={"Save"}/>
						</b>
						<i>
							<CheckIcon />
						</i>
					</Button>
				</ModalFooter>
			</Modal>
		);
	}
}

export default ModalEditLibraryLeaf;